export type WysiwygImagePickerOptions = {
  maxSize?: number;
  forcedAspectRatio?: number;
  hideAspectRatioSelector?: boolean;
};

type WysiwygImagePickerFn = (options?: WysiwygImagePickerOptions) => Promise<string | null>;

let pickerFn: WysiwygImagePickerFn | null = null;

export function registerWysiwygImagePicker(fn: WysiwygImagePickerFn): void {
  pickerFn = fn;
}

export function unregisterWysiwygImagePicker(): void {
  pickerFn = null;
}

export function pickImageForWysiwyg(options?: WysiwygImagePickerOptions): Promise<string | null> {
  if (!pickerFn) {
    return Promise.resolve(null);
  }
  return pickerFn(options);
}
